'use strict';

var classNames = require('classnames/bind');

/**
 * React hook that help working with css modules
 *
 * @param styles - styles
 * @returns {function}
 * @example
 * ```javascript
 * import styles from '../styles/Select.module.less'
 *
 * const cx = useStyles(styles)
 * const classNames = cx(className, 'container', { disabled })
 * ```
 */
function useStyles(styles) {
    return classNames.bind(styles);
}

exports.useStyles = useStyles;
//# sourceMappingURL=useStyles.js.map
